import ClearIcon from "@mui/icons-material/Clear";
import DehazeIcon from "@mui/icons-material/Dehaze";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import SearchIcon from "@mui/icons-material/Search";
import {
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "@mui/material";

const fieldRootSx = {
  height: 38,
  borderRadius: "33px",
  bgcolor: "neutral.50",
  color: "primary.900",
  fontSize: 13,
  fontWeight: 650,
  boxShadow: "inset 0px 0px 2px rgba(96, 96, 113, 0.5)",
  "& fieldset": { borderColor: "transparent" },
  "&:hover fieldset": { borderColor: "transparent" },
  "&.Mui-focused fieldset": { borderColor: "secondary.500" },
};

export default function PurchaseItemsToolbar({
  search,
  categoryId,
  categories = [],
  categoriesLoading,
  viewMode,
  disabled,
  showCategory = true,
  searchPlaceholder = "Agregar ítem",
  searchAriaLabel = "Buscar ítem para agregar",
  onSearchChange,
  onCategoryChange,
  onViewModeChange,
}) {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={1.25}
      sx={{ alignItems: { xs: "stretch", md: "center" }, justifyContent: "space-between" }}
    >
      {showCategory ? (
        <Select
          value={categoryId}
          onChange={(event) => onCategoryChange(event.target.value)}
          displayEmpty
          size="small"
          disabled={disabled || categoriesLoading}
          inputProps={{ "aria-label": "Filtrar por categoría" }}
          sx={{
            width: { xs: "100%", sm: 180 },
            ...fieldRootSx,
            bgcolor: "secondary.150",
            "& .MuiSelect-select": { display: "flex", alignItems: "center", py: 0 },
          }}
          renderValue={(value) =>
            categories.find((category) => String(category.id) === String(value))?.name ||
            (categoriesLoading ? "Cargando categorías..." : "Categoría")
          }
        >
          <MenuItem value="">Todas las categorías</MenuItem>
          {categories.map((category) => (
            <MenuItem key={category.id} value={String(category.id)}>
              {category.name}
            </MenuItem>
          ))}
        </Select>
      ) : null}

      <Stack
        direction="row"
        spacing={0.75}
        sx={{
          width: { xs: "100%", md: "auto" },
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <TextField
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder={searchPlaceholder}
          size="small"
          disabled={disabled}
          inputProps={{ maxLength: 200, "aria-label": searchAriaLabel }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "primary.900", fontSize: 18 }} />
              </InputAdornment>
            ),
            endAdornment: search ? (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  aria-label="Limpiar búsqueda de ítems"
                  onClick={() => onSearchChange("")}
                >
                  <ClearIcon sx={{ fontSize: 17 }} />
                </IconButton>
              </InputAdornment>
            ) : null,
          }}
          sx={{
            flex: { xs: 1, md: "0 0 auto" },
            minWidth: 0,
            width: { xs: "auto", md: 300 },
            "& .MuiOutlinedInput-root": {
              ...fieldRootSx,
              borderRadius: "10px",
              bgcolor: "neutral.50",
              boxShadow: "none",
              "& fieldset": { borderColor: "neutral.700" },
              "&:hover fieldset": { borderColor: "primary.900" },
            },
          }}
        />

        <ToggleButtonGroup
          exclusive
          value={viewMode}
          onChange={(_, value) => value && onViewModeChange(value)}
          size="small"
          disabled={disabled}
          aria-label="Vista de ítems"
          sx={{
            flexShrink: 0,
            alignSelf: "center",
            bgcolor: "neutral.100",
            borderRadius: "22px",
            "& .MuiToggleButton-root": {
              width: 42,
              height: 36,
              border: 0,
              borderRadius: "20px !important",
              color: "primary.900",
              "&.Mui-selected": { bgcolor: "secondary.500", color: "logoblanco" },
            },
          }}
        >
          <Tooltip title="Todos los ítems del proveedor" arrow>
            <ToggleButton value="all" aria-label="Ver todos los ítems del proveedor">
              <DehazeIcon />
            </ToggleButton>
          </Tooltip>
          <Tooltip title="Ítems seleccionados" arrow>
            <ToggleButton value="selected" aria-label="Ver ítems seleccionados">
              <HorizontalRuleIcon />
            </ToggleButton>
          </Tooltip>
        </ToggleButtonGroup>
      </Stack>
    </Stack>
  );
}
